export default {"src":"/_next/static/media/logo-grey.96ac9f5d.svg","height":673,"width":3111,"blurWidth":0,"blurHeight":0};